import { useActiveWeb3React } from "hooks"
import { injected, bsc, walletconnect, mainChainId } from 'connectors'
import { useCallback } from "react"
import { useDispatch } from "react-redux"

const CHAIN_ID = {
    BSC: 56,
    BSC_TESTNET: 97,
    MATIC: 137,
    MATIC_TESTNET: 80001,
}

const NETWORK_RPC = {
    [CHAIN_ID.BSC]: [
        'https://bsc-dataseed1.ninicoin.io',
        'https://bsc-dataseed1.defibit.io',
        'https://bsc-dataseed.binance.org/',
    ],
    [CHAIN_ID.BSC_TESTNET]: [
        // 'https://data-seed-prebsc-2-s3.binance.org:8545/',
        'https://data-seed-prebsc-1-s1.binance.org:8545/',
        'https://data-seed-prebsc-2-s2.binance.org:8545/',
    ],
    [CHAIN_ID.MATIC]: ['https://polygon-rpc.com/'],
    [CHAIN_ID.MATIC_TESTNET]: ['https://matic-mumbai.chainstacklabs.com'],
}

const BLOCK_EXPLORER = {
    [CHAIN_ID.BSC]: 'https://bscscan.com',
    [CHAIN_ID.BSC_TESTNET]: 'https://testnet.bscscan.com/',
    [CHAIN_ID.MATIC]: 'https://polygonscan.com',
    [CHAIN_ID.MATIC_TESTNET]: 'https://mumbai.polygonscan.com/',
}

const CHAIN_PARAMS = {
    [CHAIN_ID.BSC]: {
        chainId: '0x38',
        chainName: 'Binance Smart Chain',
        nativeCurrency: {
            name: 'bnb',
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrls: NETWORK_RPC[CHAIN_ID.BSC],
        blockExplorerUrls: [BLOCK_EXPLORER[CHAIN_ID.BSC]],
    },
    [CHAIN_ID.BSC_TESTNET]: {
        chainId: '0x61',
        chainName: 'Binance Smart Chain Testnet',
        nativeCurrency: {
            name: 'bnb',
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrls: NETWORK_RPC[CHAIN_ID.BSC_TESTNET],
        blockExplorerUrls: [BLOCK_EXPLORER[CHAIN_ID.BSC_TESTNET]],
    },
    [CHAIN_ID.MATIC]: {
        chainId: '0x89',
        chainName: 'Matic',
        nativeCurrency: {
            name: 'Matic',
            symbol: 'MATIC',
            decimals: 18,
        },
        rpcUrls: NETWORK_RPC[CHAIN_ID.MATIC],
        blockExplorerUrls: [BLOCK_EXPLORER[CHAIN_ID.MATIC]],
    },
    [CHAIN_ID.MATIC_TESTNET]: {
        chainId: '0x89',
        chainName: 'Matic',
        nativeCurrency: {
            name: 'Matic',
            symbol: 'MATIC',
            decimals: 18,
        },
        rpcUrls: NETWORK_RPC[CHAIN_ID.MATIC_TESTNET],
        blockExplorerUrls: [BLOCK_EXPLORER[CHAIN_ID.MATIC_TESTNET]],
    },
}

const useSwitchNetwork = () => {
    const { chainId, account, library, activate } = useActiveWeb3React()
    // const dispatch = useDispatch()
    const switchNetwork = useCallback(
        async () => {
            if (account && chainId !== mainChainId) {
                await library?.send('wallet_addEthereumChain', [CHAIN_PARAMS[mainChainId], account])
                return activate(injected)
            }
            return activate(injected)
        },
        [chainId, account, library, activate],
    )
    return { switchNetwork }
}

export default useSwitchNetwork
